import { CustomerAcquisitionLimitMemberships } from '@src/containers/Dealer/CustomerNetAcquisition/CustomerAcquisitionLimitMemberships';
import type { CustomerAcquisitionLimitMembershipsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAcquisitionLimitMembershipsPanel({
  api,
  params,
}: LayoutPanelProps<CustomerAcquisitionLimitMembershipsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-acquisition-limit-memberships-panel"
    >
      <CustomerAcquisitionLimitMemberships />
    </EntityAdminPanelShell>
  );
}
